import React from 'react';
import { Modal } from 'antd';
import StoreForm from './StoreForm';

const StoreModal = ({
  visible,
  onCancel,
  onSubmit,
  initialValues,
  title,
}) => {
  return (
    <Modal
      title={title || 'Add Store'}
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={800}
    >
      <StoreForm
        initialValues={initialValues}
        onSubmit={(values) => {
          onSubmit(values);
          onCancel();
        }}
        onCancel={onCancel}
      />
    </Modal>
  );
};

export default StoreModal;
